import styled from 'styled-components'

export const LogoContainer = styled.div`
  padding: 16px 0 0 100px;
  background-color: #FFFFFF;
  display: flex;
  align-items: center;

  img{
    width: 120px;

    @media (max-width: 550px) {
      /* Phones */
      width: 90px;
    }

    @media (max-width: 1100px) {
      /* Tablets */
      width: 90px;
    }

    @media (max-width: 1300px) {
      /* Small desktop */
      width: 90px;
    }
  }

  @media (max-width: 550px) {
    /* Phones */
    padding: 0 0 0 15px;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    padding: 0 0 0 15px;
  }

  @media (max-width: 1300px) {
    /* Small desktop */
    padding: 0 0 0 15px;
  }
`

export const MenuContainer = styled.div`
  display: grid;
  background-color: #282C34;
  color: white;
  grid-template-columns: 90% 10%;
  align-items: center;
  padding: 0px 100px 0 30px;
  
  @media (max-width: 550px) {
    /* Phones */
    padding: 0 0 0 0;
    grid-template-columns: 100%;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    padding: 0 0 0 0;
    grid-template-columns: 100%;
  }

  @media (max-width: 1300px) {
    /* Small desktop */
    padding: 0 0 0 15px;
    grid-template-columns: 100%;
  }
`

export const MenuItems = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);

  @media (max-width: 550px) {
    /* Phones */
    display: none;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    display: none;
  }

  @media (max-width: 1300px) {
    display: none;
  }
`

export const MenuItem = styled.div`
  p{
    text-transform: uppercase;
    font-weight: 500;
    text-align: center;
  }

  a{
    color: white;
    text-decoration: none;

    &:hover{
      color: #EA0B2A;
      transition: color 0.2s;
    }
  }
`

export const SignInContainer = styled.div`
  height: 25px;
  display: flex;
  align-items: center;
  font-size: 1.3em;

  div{
    border: 1px solid white;
    padding: 5px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: grid;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: 550px) {
    /* Phones */
    display: none;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    display: none;
  }

  @media (max-width: 1300px) {
    display: none;
  }
`

export const MobileMenu = styled.div`
  display: none;
  font-size: 2em;

  div{
    border: 1px solid white;
    padding: 5px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;

    &:hover{
      cursor: pointer;
    }
  }

  @media (max-width: 550px) {
    /* Phones */
    display: flex;
    align-items: center;
    justify-content: end;
  }

  @media (max-width: 1100px) {
    /* Tablets */
    display: flex;
    align-items: center;
    justify-content: end;
  }

  @media (max-width: 1300px) {
    /* Small desktop */
    display: flex;
    align-items: center;
    justify-content: end;
  }
`

export const DropdownMenu = styled.div`
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
  position: absolute;
  background: #282C34;
  color: black;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  padding: 10px;
  border-radius: 5px;
  z-index: 10;
  min-width: 150px;
`;

export const DropdownItem = styled.a`
  display: block;
  padding: 8px 12px;
  text-decoration: none;
  border-radius: 10px;
  color: black;
  &:hover {
    background: #f0f0f0;
  }
`;

export const MenuItemArrow = styled.div`
display: flex;
align-items: center;
justify-content: center;
&:hover{
      color: #EA0B2A;
      transition: color 0.2s;
    }
p{
  margin-right: 5px;
}


`